module.exports = __webpack_public_path__ + "media/customizations/hawaiian/logo-84f99e553c75e23ce9dd63f08736474b.png";